<template lang="pug">
  v-autocomplete(
    v-model="inputValue"
    :label="label"
    :items="items"
    item-text="name"
    item-value="id"
    v-bind="$attrs"
    v-on="$listeners"
    :loading="loading"
    :search-input.sync="search"
    multiple
    clearable
  )
</template>

<script>
import pdfoService from '@/services/API/_pfdo';

export default {
  props: {
    value: { type: Array, default: null },
    label: { type: String, default: 'Выберите организации' },
    municipalityId: { type:Number, required:true },
  },
  data() {
    return {
      items: [],
      loading:false,
      search:'',
    };
  },
  computed: {
    inputValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
  watch: {
    search() {
      if (this.loading) return;
      this.loading = true;

      this.loadItems();
    },
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.loadItems();
    },
    async loadItems() {
      const params = {
        'search[name]':this.search,
        'operator': this.municipalityId,
      };
      this.loading = true;
      try {
        await pdfoService.getOrganizations(params).then((response) => {
          this.items = response.data.data;
        });
      } catch (err) {
        this.$toast.error(err);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
